import { get } from "svelte/store";
import { user, contract } from "../stores/index";
import { UsersRepository } from "../repositories/index";
import { contractSwitchUrl } from "../utils/contractSwitchUrl";

// Policies and apps are contract specific, so they are refetched (with the new
// gl-contract-id header) whenever the active contract changes.
export async function switchContract(target) {
  contract.set(target);

  const userId = get(user)?.data?.id;
  const policies = await UsersRepository.getUserPolicies(userId);
  const apps = await UsersRepository.getUserApps(userId);

  user.set({ ...get(user), policies: policies.list, apps: apps.list });
}

// The microfrontends of this tab were built for the old contract, so the switch
// ends in a full reload, on the same page where the contract allows it.
export async function reloadIntoContract(target, { location, history } = window) {
  const url = contractSwitchUrl(location, target.id);

  // App.svelte derives the contract from the URL; without this it would
  // switch straight back to the old contract before the reload
  history.replaceState(null, "", url);

  try {
    await switchContract(target);
  } finally {
    location.assign(url);
  }
}
